// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CybermarathonBanner_wrapper__U2QdW {
  width: 85%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 80px;
}
.CybermarathonBanner_wrapper__U2QdW .CybermarathonBanner_left__mKIYf {
  width: 50%;
}
.CybermarathonBanner_wrapper__U2QdW .CybermarathonBanner_left__mKIYf img {
  width: 80%;
}
.CybermarathonBanner_wrapper__U2QdW .CybermarathonBanner_right__3JIvB {
  width: 50%;
}
.CybermarathonBanner_wrapper__U2QdW .CybermarathonBanner_right__3JIvB .CybermarathonBanner_title__Iiygo {
  color: #FAF9F8;
  font-size: 48px;
  font-weight: 700;
}
.CybermarathonBanner_wrapper__U2QdW .CybermarathonBanner_right__3JIvB .CybermarathonBanner_description__JWxDv {
  color: #DAD6CE;
  font-size: 20px;
  font-weight: 400;
  margin-top: 20px;
  margin-bottom: 20px;
}

@media (max-width: 1100px) {
  .CybermarathonBanner_wrapper__U2QdW {
    flex-direction: column-reverse;
  }
  .CybermarathonBanner_wrapper__U2QdW .CybermarathonBanner_right__3JIvB {
    width: 100%;
    text-align: center;
  }
  .CybermarathonBanner_wrapper__U2QdW .CybermarathonBanner_right__3JIvB .CybermarathonBanner_title__Iiygo {
    font-size: 32px;
    font-weight: 700;
  }
  .CybermarathonBanner_wrapper__U2QdW .CybermarathonBanner_left__mKIYf {
    margin-top: 32px;
    width: 100%;
    text-align: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Home/components/CybermarathonBanner/CybermarathonBanner.module.scss"],"names":[],"mappings":"AAEA;EACE,UAAA;EACA,cAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;AADF;AAGE;EACE,UAAA;AADJ;AAGI;EACE,UAAA;AADN;AAKE;EACE,UAAA;AAHJ;AAKI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAHN;AAMI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAJN;;AASA;EACE;IACE,8BAAA;EANF;EAQE;IACE,WAAA;IACA,kBAAA;EANJ;EAQI;IACE,eAAA;IACA,gBAAA;EANN;EAUE;IACE,gBAAA;IACA,WAAA;IACA,kBAAA;EARJ;AACF","sourcesContent":["@use 'assets/styles/global.scss' as *;\n\n.wrapper {\n  width: 85%;\n  margin: 0 auto;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 80px;\n\n  .left {\n    width: 50%;\n\n    img {\n      width: 80%;\n    }\n  }\n\n  .right {\n    width: 50%;\n\n    .title {\n      color: #FAF9F8;\n      font-size: 48px;\n      font-weight: 700;\n    }\n\n    .description {\n      color: #DAD6CE;\n      font-size: 20px;\n      font-weight: 400;\n      margin-top: 20px;\n      margin-bottom: 20px;\n    }\n  }\n}\n\n@media (max-width: 1100px) {\n  .wrapper {\n    flex-direction: column-reverse;\n\n    .right {\n      width: 100%;\n      text-align: center;\n\n      .title {\n        font-size: 32px;\n        font-weight: 700;\n      }\n    }\n\n    .left {\n      margin-top: 32px;\n      width: 100%;\n      text-align: center;\n    }\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `CybermarathonBanner_wrapper__U2QdW`,
	"left": `CybermarathonBanner_left__mKIYf`,
	"right": `CybermarathonBanner_right__3JIvB`,
	"title": `CybermarathonBanner_title__Iiygo`,
	"description": `CybermarathonBanner_description__JWxDv`
};
export default ___CSS_LOADER_EXPORT___;
